import { useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="header-inner">
        <a href="#hero" className="logo" onClick={closeMenu}>
          <img
            src={`${process.env.PUBLIC_URL}/images/logo-green.png`}
            alt="SAFE"
            className="logo-img"
          />
        </a>
        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <a href="#features" onClick={closeMenu}>
            Fonctionnalités
          </a>
          <a href="#security" onClick={closeMenu}>
            Sécurité
          </a>
          <a href="#tutorial" onClick={closeMenu}>
            Tutoriel
          </a>
          <a href="#faq" onClick={closeMenu}>
            FAQ
          </a>
        </nav>
        <a href="#download" className="btn btn-primary btn-sm header-cta">
          Essayer gratuitement
        </a>
        <button
          type="button"
          className="nav-toggle"
          aria-label="Menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
